import React, {useEffect, useRef, useState} from 'react';
import {Link} from "react-router-dom";
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import EventNoteIcon from '@mui/icons-material/EventNote';
import SupportIcon from '@mui/icons-material/Support';
import LogoutIcon from '@mui/icons-material/Logout';
import Data from '../utils/Data';

const Aside = () => {
    const [activeItem, setActiveItem] = useState([true, false, false, false, false, false]);
    const dashboardRef = useRef();
    const wrapperRef1 = useRef(null);
    const wrapperRef2 = useRef(null);
    const wrapperRef3 = useRef(null);
    const factorRef = useRef();
    const serviceRef = useRef();
    const ticketRef = useRef();
    const [isActive1, setIsActive1] = useState(false);
    const [isActive2, setIsActive2] = useState(false);
    const [isService, setIsService] = useState(false);
    const [top, setTop] = useState(0);
    // const [path, setPath] = useState(null);
    // console.log("isActive1", isActive1);
    useOutsideAlerter1(wrapperRef1);
    useOutsideAlerter2(wrapperRef2);

    function useOutsideAlerter1(ref) {
        useEffect(() => {
            /**
             * Alert if clicked on outside of element
             */
            function handleClickOutside1(event) {
                if (ref.current && !ref.current.contains(event.target) && !serviceRef.current.contains(event.target)) {
                    setIsActive1(false);
                }
            }

            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside1);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside1);
            };
        }, [ref]);
    }

    const ToggleClass1 = (e) => {
        if (isActive1) {
            setIsActive1(false);
        } else {
            // setTop(serviceRef.current.offsetTop + 150);
            setTop(0);
            setIsActive1(true);
        }
    };


    function useOutsideAlerter2(ref) {
        useEffect(() => {
            /**
             * Alert if clicked on outside of element
             */
            function handleClickOutside2(event) {
                if (ref.current && !ref.current.contains(event.target) && !ticketRef.current.contains(event.target)) {
                    setIsActive2(false);
                }
            }

            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside2);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside2);
            };
        }, [ref]);
    }

    const ToggleClass2 = (e) => {
        if (isActive2)
            setIsActive2(false);
        else {
            setTop(ticketRef.current.offsetTop + 150);
            setIsActive2(true);
            // setActiveItem(() => [
            //     false, false, false, true
            // ]);
        }
    };
    const myComponentStyle = {
        position: 'fixed',
        zIndex: 10,
        inset: '0px 0px auto auto',
        margin: 0,
        width: 'fit-content',
        transform: 'translate(' + -140 + 'px, ' + top + 'px)',
    }
    let path = window.location.pathname;
    useEffect(() => {
        // console.log("path", path)
        if (path === '/' || path === '/edit-prof' || path === '/change-pass') {
            setActiveItem(() => [
                true, false, false, false, false, false
            ]);

        }
        if (path.startsWith('/tickets')) {
            setActiveItem(() => [
                false, false, false, false, true, false
            ]);
        }
        if (path.startsWith('/factors')) {
            setActiveItem(() => [
                false, false, false, true, false, false
            ]);
        }
        if (path.startsWith('/servers')) {
            setActiveItem(() => [
                false, false, true, false, false, false
            ]);
        }
        if (path.startsWith('/services')) {
            setActiveItem(() => [
                false, false, false, false, false, true
            ]);
        }
        if (path === '/wallet') {
            setActiveItem(() => [
                false, true, false, false, false, false
            ]);
        }
    }, [path])

    return (
        <React.Fragment>
            <div id="kt_aside" className="aside pb-5 pt-5 pt-lg-0 print-none" data-kt-drawer="true"
                 data-kt-drawer-name="aside" data-kt-drawer-activate="{default: true, lg: false}"
                 data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'80px', '300px': '100px'}"
                 data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_aside_mobile_toggle">
                <div className="aside-logo" id="kt_aside_logo">
                    <div className="d-flex align-items-center justify-content-center">
                        <a href="https://zaminhost.com/" target={"_blank"}>
                            <img alt="Logo"
                                 src="assets/logo.png"
                                 className="h-80px logo"/>
                        </a>
                    </div>
                </div>
                <div className="aside-menu overflow-auto" id="kt_aside_menu" style={{height: 'calc(100svh - 120px)'}}>
                    <div className="hover-scroll-overlay-y pe-lg-n1" id="kt_aside_menu_wrapper"
                         data-kt-scroll="true" data-kt-scroll-height="auto"
                         data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
                         data-kt-scroll-wrappers="#kt_aside, #kt_aside_menu" data-kt-scroll-offset="5px">
                        <div
                            className="menu menu-column menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-bold"
                            id="#kt_aside_menu" data-kt-menu="true">

                            <Link to={"/"}
                                  className={activeItem[0] ? "menu-item here show py-3 active" : "menu-item here show py-3"}
                                  ref={dashboardRef}>
									<span className="menu-link menu-center" title="داشبورد" data-bs-toggle="tooltip"
                                          data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right">
										<span className="menu-icon me-0">
											<DashboardIcon className={"f-18"}/>
										</span>
										<span className="menu-title menu-subject">داشبورد</span>
									</span>
                            </Link>

                            <Link to={"/wallet"}
                                  className={activeItem[1] ? "menu-item here show py-3 active" : "menu-item here show py-3"}
                                  ref={dashboardRef}>
									<span className="menu-link menu-center" title="کیف پول من" data-bs-toggle="tooltip"
                                          data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right">
										<span className="menu-icon me-0">
											<AccountBalanceWalletIcon className={"f-18"}/>
										</span>
										<span className="menu-title menu-subject">کیف پول من</span>
									</span>
                            </Link>

                            <Link to={"/services"}
                                  className={activeItem[5] ? "menu-item here show py-3 active" : "menu-item here show py-3"}>
									<span className="menu-link menu-center" title="سرویس های من"
                                          data-bs-toggle="tooltip"
                                          data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right">
										<span className="menu-icon me-0">
											<MiscellaneousServicesIcon color={"white"} className={"f-18"}/>
										</span>
										<span className="menu-title menu-subject text-center">سرویس های من</span>
									</span>
                            </Link>
                            <div id={"service"} onClick={ToggleClass1} data-kt-menu-trigger="click" ref={serviceRef}
                                 data-kt-menu-placement="left-start"
                                 className={"menu-item py-2 show menu-dropdown " + (activeItem[2] ? "active" : "")}>
                                <div className="menu-link menu-center position-relative" title="خرید سرویس"

                                     data-bs-toggle="tooltip"
                                     data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                         fill="#fff" className="bi bi-hdd-stack" viewBox="0 0 16 16">
                                        <path
                                            d="M14 10a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h12zM2 9a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H2z"/>
                                        <path
                                            d="M5 11.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM14 3a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/>
                                        <path
                                            d="M5 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
                                    </svg>
                                    <span className="menu-title menu-subject">خرید سرویس</span>
                                </div>
                                {
                                    isActive1 &&
                                    <div style={myComponentStyle} ref={wrapperRef1}
                                         className={"menu-sub menu-sub-dropdown overflow-auto px-1 py-4 show align-items-start h-100"}>
                                        {/*<div className="menu-item">*/}
                                        {/*    <Link to={"/services"} className="menu-link"*/}
                                        {/*    >*/}
                                        {/*		<span className="menu-bullet">*/}
                                        {/*			<span className="bullet bullet-dot"/>*/}
                                        {/*		</span>*/}
                                        {/*        <span className="menu-title">سرویس های من</span>*/}
                                        {/*    </Link>*/}
                                        {/*</div>*/}
                                        <div className={'p-4 border-bottom'}>
                                            <h3>خرید سرویس</h3>
                                        </div>
                                        {Data.sidebar.servers_category.map((category, index) => (
                                            <div className="menu-item" key={index}>
                                                <Link className="menu-link" to={category.url}
                                                >
												<span className="menu-bullet">
													<span className="bullet bullet-dot"/>
												</span>
                                                    <span className="menu-title">{category.name}</span>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>
                            <Link to={"/factors"} data-kt-menu-trigger="click" data-kt-menu-placement="left-start"
                                  className={activeItem[3] ? "menu-item here show py-3 active" : "menu-item here show py-3"}
                                  ref={factorRef}>
									<span className="menu-link menu-center" title="فاکتورها" data-bs-toggle="tooltip"
                                          data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right">
										<span className="menu-icon me-0">
											<EventNoteIcon color={"white"} className={"f-18"}/>
										</span>
										<span className="menu-title menu-subject">فاکتورها</span>
									</span>
                            </Link>
                            <div id={"ticket"} onClick={ToggleClass2} data-kt-menu-trigger="click" ref={ticketRef}
                                 data-kt-menu-placement="left-start"
                                 className={"menu-item py-2 show menu-dropdown " + (activeItem[4] ? "active" : "")}>
                                <div className="menu-link menu-center" title="تیکت ها" data-bs-toggle="tooltip"
                                     data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="right">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#fff"
                                         className="bi bi-headset" viewBox="0 0 16 16">
                                        <path
                                            d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5z"/>
                                    </svg>
                                    <span className="menu-title menu-subject">تیکت ها</span>
                                </div>
                                {
                                    isActive2 &&
                                    <div style={myComponentStyle} ref={wrapperRef2}
                                         className={"menu-sub menu-sub-dropdown px-1 py-4 show"}>
                                        <div className="menu-item">
                                            <Link to={"/tickets"} className="menu-link">
												<span className="menu-bullet">
													<span className="bullet bullet-dot"/>
												</span>
                                                <span className="menu-title">تیکت های من</span>
                                            </Link>
                                        </div>
                                        <div className="menu-item">
                                            <Link className="menu-link" to={"/tickets/add-ticket"}>
												<span className="menu-bullet">
													<span className="bullet bullet-dot"/>
												</span>
                                                <span className="menu-title">ثبت تیکت جدید</span>
                                            </Link>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </React.Fragment>
    );
};

export default Aside;